import { ReactElement } from 'react';
import {
    Box, SimpleGrid, Text, Stack, Flex, useColorModeValue, Image,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    AspectRatio,
    VStack
} from '@chakra-ui/react';

import rendering_vantage from '../assets/renderings/rendering_vantage_cropped.png'
import rendering_zebra from '../assets/renderings/features_stills.png'
import rendering_tm_villa from '../assets/renderings/rendering_tm_villa.png'
import rendering_tm_xmas from '../assets/renderings/rendering_tm_xmas.png'
import rendering_bedroom from '../assets/renderings/rendering_VirtualArch_Image28_000_igedit.jpg'

import d1hero from '../assets/d1/d1_fk_analysis.png';

interface FeatureProps {
    title: string;
    text: string;
    icon: ReactElement;
}

const Feature = ({ title, text, icon }: FeatureProps) => {
    return (
        <div id='renderings'>
        <Stack>
            <Flex
                align={'center'}
                justify={'center'}
                bg={useColorModeValue('white', 'gray.800')}
                mb={1}
                rounded={'2xl'}
            // boxShadow={'2xl'}
            >
                {icon}
            </Flex>
            <Text fontWeight={'thin'}
                textTransform='uppercase'
                color={useColorModeValue('black', 'white')}
                fontSize={'lg'}
                textAlign='center'
                letterSpacing={1}
            >{title}</Text>
            <Text
                color={useColorModeValue('gray.800', 'gray.200')}
                textAlign='center'
                fontSize={{ base: 'sm', lg: 'sm' }}
            >{text}
            </Text>
        </Stack>
        </div>
    );
};

export default function Renderingstills() {
    return (
        <div id='renderings'>
            <Box mt={{ base: 20, md: 20 }}
                mx={'16px'}
            >
                <Text
                    textAlign={['center', 'center']}
                    pb={4}
                    fontSize={{base:'3xl',sm:'4xl'}}
                    letterSpacing={2}
                    color={useColorModeValue('black', 'white')}
                    fontWeight='thin'
                    textTransform='uppercase'
                    lineHeight='1'
                >
                    Renderings</Text>

                <SimpleGrid columns={{ base: 2, md: 4 }} spacing={6}>

                    <Feature icon={
                        <Image
                            src={rendering_zebra}
                            alt='rendering'
                            w={80}
                            rounded={'2xl'} />} />
                    <Feature icon={
                        <Image
                            src={rendering_vantage}
                            alt='rendering'
                            w={80}
                            rounded={'2xl'} />} />
                    <Feature icon={
                        <Image
                            src={rendering_tm_xmas}
                            alt='rendering'
                            w={80}
                            rounded={'2xl'} />} />
                    <Feature icon={
                        <Image
                            src={rendering_tm_villa}
                            // src={rendering_bedroom}
                            alt='rendering'
                            w={80}
                            rounded={'2xl'} />} />
                </SimpleGrid>

                <Accordion allowToggle>
                    <AccordionItem>
                        <AccordionButton>
                            <Box as="span" flex='1' textAlign='left'>
                                <Text
                                    color='gray.400'
                                    fontSize='sm'
                                    fontWeight='light'
                                    lineHeight='0.9'
                                    mb={2}
                                >
                                    See more: Renderings</Text>
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4}>
                            <VStack>
                                <AspectRatio
                                    w={'full'}
                                    maxW='800px' ratio={5 / 1}
                                >
                                    <Image
                                        // border='1px'
                                        // borderColor='gray.300'
                                        src={d1hero}
                                        alt='City Typologies'
                                        rounded={'2xl'}
                                    />
                                </AspectRatio>
                                <Text
                                    // size='md'
                                    textAlign='center'
                                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                                    color={useColorModeValue('gray.800', 'gray.200')}
                                >
                                    Freshkills Park Analysis | F2016</Text>
                            </VStack>
                            <VStack>
                                <AspectRatio
                                    w={'full'}
                                    maxW='800px' 
                                    ratio={192 / 108}
                                >
                                    <Image
                                        src={rendering_bedroom}
                                        alt='Virtual Architecture'
                                        rounded={'2xl'}
                                    />
                                </AspectRatio>
                                <Text
                                    // size='md'
                                    textAlign='center'
                                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                                    color={useColorModeValue('gray.800', 'gray.200')}
                                >
                                    Chalet</Text>
                            </VStack>
                            <SimpleGrid columns={{ base: 1, md: 4 }} spacing={10}>

                                {/* <Feature
                                    icon={
                                        <Image
                                            src={d1hero}
                                            alt='Freshkills'
                                            // w={80}
                                            // w={'full'}
                                            h={80}
                                            rounded={'2xl'}
                                        />
                                    }
                                /> */}
 

                            </SimpleGrid>
                        </AccordionPanel>
                    </AccordionItem>
                </Accordion>

            </Box>
        </div>
    );
}